import { SupportedLocaleIdentifier } from '@syconium/weeping-figs'

import { useTranslatedLocalization } from '../../../../app/_hooks/useTranslatedLocalization'

const EN_US_STYLE_GUIDE_URL =
  'https://assets.ctfassets.net/5j6wpslh72e4/68cSTwdYwlFVYZv4f2Dr0H/04224b0478253e9dda0a30a577742412/FIGS_TEAMS_Core_Catalog_en-US.pdf'

export const useTranslatedStyleGuide = () => {
  const styleGuideMap: Partial<Record<SupportedLocaleIdentifier, string>> = {
    'de-DE':
      'https://assets.ctfassets.net/5j6wpslh72e4/7xIn9Bt18M1DdfFI8aGbYU/4f4ea35ef77993bbbe88e0366ba8152b/FIGS_TEAMS_Core_Catalog_de-DE.pdf',
    'en-AU':
      'https://assets.ctfassets.net/5j6wpslh72e4/1CkqJ5XMGhV7ihVs3xWKrq/469f359a120d51db5b3cb8679ed7834a/FIGS_TEAMS_Core_Catalog_en-AU.pdf',
    'en-US': EN_US_STYLE_GUIDE_URL,
    'en-GB':
      'https://assets.ctfassets.net/5j6wpslh72e4/2O1gTzz4LK94zMZdnbTSJO/149142b3713229cd1d2b5588abf19643/FIGS_TEAMS_Core_Catalog_en-GB.pdf',
    'en-EU':
      'https://assets.ctfassets.net/5j6wpslh72e4/2O1gTzz4LK94zMZdnbTSJO/149142b3713229cd1d2b5588abf19643/FIGS_TEAMS_Core_Catalog_en-GB.pdf',
    'es-ES':
      'https://assets.ctfassets.net/5j6wpslh72e4/5EHQkjMrVW9EOZQTVeZeM8/fca5f1ca71234e355b71056f0f58cb2c/FIGS_TEAMS_Core_Catalog_es-ES.pdf',
    'es-MX':
      'https://assets.ctfassets.net/5j6wpslh72e4/3NevsV9mKkvBO1eLnPbhR8/ac27f86d98f96749a61320f804e02fd7/FIGS_TEAMS_Core_Catalog_es-MX.pdf',
    'es-US':
      'https://assets.ctfassets.net/5j6wpslh72e4/QpWnJn1xsi4q8ctMhW6lW/8d85fde8b3f85b105c0ec73ba02b2616/FIGS_TEAMS_Core_Catalog_es-US.pdf',
    'fr-CA':
      'https://assets.ctfassets.net/5j6wpslh72e4/5svIF3rEeKhYpOZxwGdfvy/cfe8229b67cdf0ea6234926079beb399/FIGS_TEAMS_Core_Catalog_fr-CA.pdf',
    'fr-FR':
      'https://assets.ctfassets.net/5j6wpslh72e4/2J7AsVmJxWjoPM6upv17i5/622b7955ce982b5ab0d3820577cc39d2/FIGS_TEAMS_Core_Catalog_fr-FR.pdf',
    'ja-JP':
      'https://assets.ctfassets.net/5j6wpslh72e4/56U8doI17dlUfomy2DFsLa/7fc2bf0e0291b11a8f9dc108ef7a8663/FIGS_TEAMS_Core_Catalog_ja-JP.pdf',
  }

  const {
    data: { locale },
  } = useTranslatedLocalization()

  return styleGuideMap[locale] ?? EN_US_STYLE_GUIDE_URL
}
